import React from 'react';
import { BulletedListElement as BulletedListType } from '../../types/element.types';

interface BulletedListElementProps {
  element: BulletedListType;
}

/**
 * Bulleted List Element Renderer
 */
const BulletedListElement: React.FC<BulletedListElementProps> = ({ element }) => {
  const listStyle = element.settings?.listStyle || 'disc';
  
  return (
    <ul
      className="bulleted-list-element"
      style={{
        ...element.styles,
        listStyleType: listStyle,
      } as React.CSSProperties}
    >
      {Array.isArray(element.content) && element.content.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};

export default BulletedListElement;

